import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
// import TypoFramed from '../../components/TypoFramed';
import PopupPage from '../../components/PopupPage';
import styles from './styles';
import PopupTimeline from '../../components/PopupTimeline';

class PopupEscort extends React.Component {
  render() {
    const { data, classes, open, onClose, baseUrl, popupsState, onPopup } = this.props;
    const imgSrc = `${baseUrl}/popups/${parse(data.popup.escort.imgSrc)}`;
    return (
      <PopupPage open={open} onClose={onClose}>
        <Typography variant="h3" className={classes.title}>
          {parse(data.popup.escort.title)}
        </Typography>
        <img src={imgSrc} alt="" className={classes.image} />
        <div className={classes.desc}>
          <Typography variant="body1">{parse(data.popup.escort.desc1)}</Typography>
          <Typography variant="body1">{parse(data.popup.escort.desc2)}</Typography>
        </div>
        <PopupTimeline
          timelinePopupData={data.popup.jacquesWolfrom}
          open={!!popupsState.popupJacquesWolfrom}
          onClose={() => onPopup('popupJacquesWolfrom', false)}
        ></PopupTimeline>
      </PopupPage>
    );
  }
}

PopupEscort.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(PopupEscort);
